<template>
    <div>
        <!--edit-->
        <div class="container" v-if="EditView">
            <div class="page-inner">
                <div class="page-header">
                    <h3 class="fw-bold mb-3">Suporte</h3>
                    <ul class="breadcrumbs mb-3">
                        <li class="nav-home"> <router-link to="/home"><i class="fa fa-home"></i></router-link> </li>
                        <li class="separator"><i class="fa fa-chevron-right"></i> </li>
                        <li class="nav-item"><a href="#" @click.prevent="EditCancel()">Cadastro de tipos de chamados</a>
                        </li>
                        <li class="separator"><i class="fa fa-chevron-right"></i> </li>
                        <li class="nav-item"><a href="#" @click="EditNew()">Incluir Novo</a> </li>
                    </ul>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="card-body">
                                <v-tabs v-model="tab" color="deep-purple-accent-4" bg-color="#dadcdf">
                                    <v-tab value="dados" class="tabinfo"
                                        style="font-size: 13px;text-transform: none !important;">Dados Tipos
                                        Chamados</v-tab>
                                    <div v-if="TiposChamados.stcId != 0">
                                        <v-tab value="etapas" class="tabinfo"
                                            style="font-size: 13px;text-transform: none !important;">Etapas do
                                            Chamado</v-tab>
                                    </div>
                                </v-tabs>
                                <v-window v-model="tab">
                                    <!--dados-->
                                    <v-window-item value="dados">
                                        <v-form>
                                            <v-container>
                                                <div class="row">
                                                    <div class="col-md-2 col-lg-2" v-show="false">
                                                        <div class="form-group">
                                                            <label>Identificador</label>
                                                            <input v-model="TiposChamados.stcId" type="text"
                                                                class="form-control" placeholder="Id" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-9 col-lg-9">
                                                        <div class="form-group">
                                                            <label>Tipo de Chamado</label>
                                                            <input v-model="TiposChamados.stcNomeTipoChamado"
                                                                type="text" class="form-control"
                                                                placeholder="Tipo de Chamado" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3">
                                                        <div class="form-group" style="padding-top: 30px;">
                                                            <div class="form-check">
                                                                <input v-model="TiposChamados.stcVisivelGarantePay"
                                                                    type="checkbox" class="form-check-input"
                                                                    id="checkboxVisivelGarantePay" />
                                                                <label class="form-check-label"
                                                                    for="checkboxVisivelGarantePay">Visível
                                                                    GarantePay</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3">
                                                        <div class="form-group">
                                                            <div class="form-check">
                                                                <input v-model="TiposChamados.stcVisivelGarantidora"
                                                                    type="checkbox" class="form-check-input"
                                                                    id="checkboxVisivelGarantidora" />
                                                                <label class="form-check-label"
                                                                    for="checkboxVisivelGarantidora">Visível
                                                                    Garantidora</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3">
                                                        <div class="form-group">
                                                            <div class="form-check">
                                                                <input v-model="TiposChamados.stcVisivelImobiliaria"
                                                                    type="checkbox" class="form-check-input"
                                                                    id="checkboxVisivelImobiliaria" />
                                                                <label class="form-check-label"
                                                                    for="checkboxVisivelImobiliaria">Visível
                                                                    Imobiliária</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3">
                                                        <div class="form-group">
                                                            <div class="form-check">
                                                                <input v-model="TiposChamados.stcVisivelParceiro"
                                                                    type="checkbox" class="form-check-input"
                                                                    id="checkboxVisivelParceiro" />
                                                                <label class="form-check-label"
                                                                    for="checkboxVisivelParceiro">Visível
                                                                    Parceiro</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3">
                                                        <div class="form-group">
                                                            <div class="form-check">
                                                                <input v-model="TiposChamados.stcVisivelCliente"
                                                                    type="checkbox" class="form-check-input"
                                                                    id="checkboxVisivelCliente" />
                                                                <label class="form-check-label"
                                                                    for="checkboxVisivelCliente">Visível Cliente</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </v-container>
                                        </v-form>
                                    </v-window-item>
                                    <!--dados-->
                                    <!--dados-->
                                    <v-window-item value="etapas">
                                        <v-form>
                                            <v-container>
                                                <div class="row">
                                                    <div class="col-md-2 col-lg-2" v-show="false">
                                                        <div class="form-group">
                                                            <label>Identificador</label>
                                                            <input v-model="StatusChamado.sscId" type="text"
                                                                class="form-control" placeholder="Id" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4">
                                                        <div class="form-group">
                                                            <label>Etapa</label>
                                                            <input v-model="StatusChamado.sscNomeEtapa" type="text"
                                                                class="form-control" placeholder="Etapa" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-2 col-lg-2">
                                                        <div class="form-group">
                                                            <label>Chama Etapa</label>
                                                            <input v-model="StatusChamado.sscOrdem" type="number"
                                                                class="form-control" placeholder="Ordem" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3" v-if="TipoPessoas != ''">
                                                        <div class="form-group">
                                                            <label>Avisar Quem?</label>
                                                            <select v-model="StatusChamado.tpeId"
                                                                class="form-select form-control" id="defaultSelect"
                                                                @change="TipoPessoaSelected()">
                                                                <option :value="null">Selecione</option>
                                                                <option v-for="optionTipo in TipoPessoas"
                                                                    :key="optionTipo.tpeId" :value="optionTipo.tpeId">{{
                                                                    optionTipo.tpeNome }}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3" v-if="TipoUsuario != '' && StatusChamado.tpeId!= 4 && StatusChamado.tpeId!= 5">
                                                        <div class="form-group">
                                                            <label>Perfil Usuário</label>
                                                            <select v-model="StatusChamado.tusId"
                                                                class="form-select form-control">
                                                                <option v-for="optionTipo in TipoUsuario"
                                                                    :key="optionTipo.tusId" :value="optionTipo.tusId">{{
                                                                    optionTipo.tusNome }}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3">
                                                        <button v-if="StatusChamado.sscId == 0" type="button"
                                                            class="btn btn-info" @click.prevent="AddStatus()"
                                                            style="color:#ffffff;margin-top: 40px;">
                                                            Inserir
                                                        </button>
                                                        <button v-else type="button" class="btn btn-info"
                                                            @click.prevent="PutStatus()"
                                                            style="color:#ffffff;margin-top: 40px;">
                                                            Alterar
                                                        </button>
                                                        <!--a href="#" @click="EditStatusCancel()"
                                                            style="margin-top: 40px;" class="btn btn-link">Cancelar</!--a-->
                                                    </div>
                                                </div>
                                                <div class="row" style="padding-top: 20px;">
                                                    <v-table>
                                                        <thead>
                                                            <tr>
                                                                <th class="text-left">
                                                                    Id
                                                                </th>
                                                                <th class="text-left">
                                                                    Etapa
                                                                </th>
                                                                <th class="text-left">
                                                                    Chama Etapa
                                                                </th>
                                                                <th class="text-left">
                                                                    Avisar
                                                                </th>
                                                                <th class="text-left">
                                                                    Perfil
                                                                </th>
                                                                <th colspan="2">
                                                                    Ações
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody v-if="ListStatusChamados != '' && TipoPessoas != '' && TipoUsuario != ''">
                                                            <tr v-for="item in ListStatusChamados"
                                                                :key="item.sscId">
                                                                 <td>{{ item.sscId }}</td>
                                                                <td>{{ item.sscNomeEtapa }}</td>
                                                                <td>{{ item.sscOrdem }}</td>
                                                                <td>{{(item.tpeId != '' && item.tpeId != null) ?TipoPessoas.filter(x => x.tpeId ==
                                                                    item.tpeId)[0].tpeNome : 'GarantePay' }}</td>
                                                                 <td>{{ (item.tusId!= '' && item.tusId!= null) ? TipoUsuarioGeral.filter(x => x.tusId ==
                                                                    item.tusId)[0].tusNome: '' }}</td>
                                                                <td style="text-align: center;">
                                                                    <v-btn icon @click.prevent="EditarStatus(item)"
                                                                        variant="text">
                                                                        <v-icon>mdi-file-edit</v-icon>
                                                                        <v-tooltip activator="parent"
                                                                            location="top">Editar</v-tooltip>
                                                                    </v-btn>
                                                                </td>
                                                                <td>
                                                                    <v-btn icon
                                                                        @click.prevent="DeleteStatus(item)"
                                                                        variant="text">
                                                                        <v-icon>mdi-delete-forever-outline</v-icon>
                                                                        <v-tooltip activator="parent"
                                                                            location="top">Excluir</v-tooltip>
                                                                    </v-btn>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </v-table>
                                                </div>
                                            </v-container>
                                        </v-form>
                                    </v-window-item>
                                    <!--dados-->
                                </v-window>
                            </div>
                        </div>
                    </div>
                    <div class="card-action" v-if="tab == 'dados'">
                        <button v-if="TiposChamados.stcId != 0" type="button" class="btn btn-success"
                            style="color:#ffffff;" @click="Put()">
                            Alterar
                        </button>
                        <button v-else type="button" class="btn btn-success" style="color:#ffffff;" @click="Add()">
                            Salvar
                        </button>
                        <a href="#" @click="EditCancel()" class="btn btn-link">Cancelar</a>
                    </div>
                </div>
            </div>
        </div>
        <!--grid-->
        <div class="container" v-if="!EditView">
            <div class="page-inner">
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="card-header">
                                <div class="d-flex align-items-center">
                                    <h4 class="card-title">Cadastro de tipos chamados</h4>
                                    <a href="#" @click="EditNew()" class="btn btn-sm btn-secondary ms-auto">
                                        <i class="fa fa-plus"></i>
                                        Incluir Novo
                                    </a>
                                </div>
                            </div>
                            <div class="card-body">
                                <v-row>
                                    <v-col cols="12" md="6" style="padding-bottom: 30px;">
                                        <v-text-field v-model="searchValue" label="Pesquisa" variant="underlined"
                                            required></v-text-field>
                                    </v-col>
                                </v-row>
                                <easy-data-table :headers="headers" :items="ListTiposChamados" v-model="itemsSelected"
                                    alternating theme-color="#364f66" table-class-name="customize-table"
                                    header-text-direction="center" body-text-direction="center"
                                    rows-per-page-message="Linhas por pagina" :search-value="searchValue">
                                    <template #item-stcVisivelGarantePay="item">
                                        <span>{{ item.stcVisivelGarantePay ? 'Sim' : 'Não' }}</span>
                                    </template>
                                    <template #item-stcVisivelGarantidora="item">
                                        <span>{{ item.stcVisivelGarantidora ? 'Sim' : 'Não' }}</span>
                                    </template>
                                    <template #item-stcVisivelImobiliaria="item">
                                        <span>{{ item.stcVisivelImobiliaria ? 'Sim' : 'Não' }}</span>
                                    </template>
                                    <template #item-stcVisivelParceiro="item">
                                        <span>{{ item.stcVisivelParceiro ? 'Sim' : 'Não' }}</span>
                                    </template>
                                    <template #item-stcVisivelCliente="item">
                                        <span>{{ item.stcVisivelCliente ? 'Sim' : 'Não' }}</span>
                                    </template>
                                    <template #item-actions="item">
                                        <v-btn icon @click="EditGrid(item)" style="margin-right: 10px;" variant="text">
                                            <v-icon class="editiconcor">mdi-file-edit</v-icon>
                                            <v-tooltip activator="parent" location="top">Editar</v-tooltip>
                                        </v-btn>

                                        <v-btn icon @click="DeleteGrid(item)" variant="text">
                                            <v-icon class="deliconcor">mdi-delete-forever</v-icon>
                                            <v-tooltip activator="parent" location="top">Excluir</v-tooltip>
                                        </v-btn>
                                    </template>
                                </easy-data-table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import EasyDataTable from 'vue3-easy-data-table';
export default {
    name: 'SupTiposChamadosView',
    components: {
        EasyDataTable
    },
    data: () => ({
        EditView: false,
        tab: null,
        TipoUsuario: [],
        TipoPessoas: [],
        TipoUsuarioGeral:[],
        PerfilUsuarios:[],
        // dados
        TiposChamados: {
            stcId: 0,
            stcNomeTipoChamado: '',
            stcVisivelGarantePay: false,
            stcVisivelGarantidora: false,
            stcVisivelImobiliaria: false,
            stcVisivelParceiro: false,
            stcVisivelCliente: false,
        },
        ListTiposChamados: [],
        // dados
        // etapas
        StatusChamado: {
            sscId: 0,
            stcId: 0,
            sscNomeEtapa: '',
            tpeId: null,
            tusId: null,
            sscOrdem: 0,
        },
        ListStatusChamados: [],
        // etapas
        headers: [
            { text: "Id", value: "stcId", sortable: true, },
            { text: "Nome", value: "stcNomeTipoChamado", sortable: true, },
            { text: "GarantePay", value: "stcVisivelGarantePay", sortable: true, },
            { text: "Garantidoras", value: "stcVisivelGarantidora", sortable: true, },
            { text: "Imobiliárias", value: "stcVisivelImobiliaria", sortable: true, },
            { text: "Parceiros", value: "stcVisivelParceiro", sortable: true, },
            { text: "Clientes", value: "stcVisivelCliente", sortable: true, },
            { text: 'Ações', value: 'actions' }
        ],
        itemsSelected: [],
        selectedItem: null,
        searchValue: '',
    }),
    methods: {
        //edit
        EditNew() {
            this.ListStatusChamados = [];
            this.EditView = true;
            this.TiposChamados.stcId = 0;
            this.TiposChamados.stcNomeTipoChamado = '';
            this.TiposChamados.stcVisivelGarantePay = false;
            this.TiposChamados.stcVisivelGarantidora = false;
            this.TiposChamados.stcVisivelImobiliaria = false;
            this.TiposChamados.stcVisivelParceiro = false;
            this.TiposChamados.stcVisivelCliente = false;
            //status
            this.StatusChamado.sscId = 0;
            this.StatusChamado.sscNomeEtapa = '';
            this.StatusChamado.tpeId = null;
            this.StatusChamado.tusId = null;
            this.StatusChamado.sscOrdem = 0;
            this.tab = 'dados';
        },
        EditCancel() {
            this.$router.go(0);
        },
        EditGrid(item) {
            this.EditView = true;
            this.tab = 'dados';
            if (item.stcId != '') {
                axios.get(`/Telas/ConfiguracoesChamados/GetByIdTiposChamados/` + item.stcId)
                    .then(response => {
                        this.TiposChamados = response.data;

                        //carregar status
                        this.CarregaStatus(item.stcId);
                    });
            }
        },
        Add() {
            if (this.TiposChamados.stcNomeTipoChamado == '' || this.TiposChamados.stcNomeTipoChamado == null) {
                this.$mensagemAviso("Nome Tipo Chamado Obrigatório.")
            }
            else {
                axios.post(`/Telas/ConfiguracoesChamados/AddTiposChamados`, this.TiposChamados)
                    .then(response => {
                        if (response.data > 0) {
                            this.TiposChamados.stcId = response.data;
                            this.$mensagemAvisoSucesso("Registro Incluído. abas para informações adicionais liberadas.")
                            this.CarregaStatus(this.TiposChamados.stcId);
                        }
                    });
            }
        },
        Put() {
            if (this.TiposChamados.stcNomeTipoChamado == '' || this.TiposChamados.stcNomeTipoChamado == null) {
                this.$mensagemAviso("Nome Tipo Chamado Obrigatório.")
            }
            else {
                axios.put(`/Telas/ConfiguracoesChamados/UpdateTiposChamados`, this.TiposChamados)
                    .then(response => {
                        if (response.status == 200) {
                            this.$mensagemAvisoSucesso("Registro Alterado.")
                            this.Get();
                        }
                    });
            }
        },
        //edit
        DeleteGrid(item) {

            this.$mensagemConfirma('Tem certeza que deseja excluir?')
                .then((result) => {
                    if (result.isConfirmed) {
                        // Lógica para excluir o item
                        const param1 = item.stcId;
                        axios.delete(`/Telas/ConfiguracoesChamados/DeleteTiposChamados/${param1}`)
                            .then(response => {
                                if (response.status == 200) {
                                    this.$mensagemAvisoSucesso("Registro Excluido.")
                                    this.Get();
                                }
                            });
                    }
                });
        },
        //status
        CarregaStatus(_stcId) {
            axios.get(`/Telas/ConfiguracoesChamados/GetAllByStcIdStatusChamados/` + _stcId)
                .then(response => {
                    this.ListStatusChamados = response.data;
                    //console.log('this.ListStatusChamados')
                    //console.log(this.ListStatusChamados)
                });
        },
        async AddStatus() {
            if (this.StatusChamado.sscNomeEtapa == null || this.StatusChamado.sscNomeEtapa === '') {
                this.$mensagemAviso("Nome Etapa obrigatório.");
            }
            else if ((this.StatusChamado.tusId == null || this.StatusChamado.tusId === '') && this.StatusChamado.tpeId != 4 && this.StatusChamado.tpeId != 5) {
                this.$mensagemAviso("Tipo Perfil obrigatório.");
            }
            else if (this.StatusChamado.sscOrdem == null || this.StatusChamado.sscOrdem === '') {
                this.$mensagemAviso("Ordem obrigatório.");
            }
            else {
                // Continuação do processamento
                this.StatusChamado.stcId = this.TiposChamados.stcId;
                if (this.StatusChamado.tpeId != '' && this.StatusChamado.tpeId != null) {
                    this.StatusChamado.tpeId = parseInt(this.StatusChamado.tpeId, 10);
                }
                this.StatusChamado.sscOrdem = parseInt(this.StatusChamado.sscOrdem, 10);
                if (this.StatusChamado.tpeId != 4 && this.StatusChamado.tpeId != 5) {
                    this.StatusChamado.tusId = parseInt(this.StatusChamado.tusId, 10);
                }

                await axios.post(`/Telas/ConfiguracoesChamados/AddStatusChamados`, this.StatusChamado)
                    .then(response => {
                        if (response.data > 0) {
                            this.StatusChamado.sscId = response.data;
                            this.$mensagemAvisoSucesso("Status Incluído")
                            this.StatusChamado.sscId = 0;
                            this.StatusChamado.sscNomeEtapa = '';
                            this.StatusChamado.tpeId = null;
                            this.StatusChamado.tusId = null;
                            this.StatusChamado.sscOrdem = 0;
                            this.CarregaStatus(this.StatusChamado.stcId);
                        }
                    });
            }
        },
        EditarStatus(value) {
            this.StatusChamado = value;
        },
        PutStatus() {

            if (this.StatusChamado.sscNomeEtapa == null || this.StatusChamado.sscNomeEtapa === '') {
                this.$mensagemAviso("Nome Etapa obrigatório.");
            }
            else if ((this.StatusChamado.tusId == null || this.StatusChamado.tusId === '') && this.StatusChamado.tpeId != 4 && this.StatusChamado.tpeId != 5) {
                this.$mensagemAviso("Tipo Perfil obrigatório.");
            }
            else if (this.StatusChamado.sscOrdem == null || this.StatusChamado.sscOrdem === '') {
                this.$mensagemAviso("Ordem obrigatório.");
            }
            else {
                this.StatusChamado.stcId = this.TiposChamados.stcId;
                if (this.StatusChamado.tpeId != '' && this.StatusChamado.tpeId != null) {
                    this.StatusChamado.tpeId = parseInt(this.StatusChamado.tpeId, 10);
                }
                this.StatusChamado.sscOrdem = parseInt(this.StatusChamado.sscOrdem, 10);
                if (this.StatusChamado.tpeId != 4 && this.StatusChamado.tpeId != 5) {
                    this.StatusChamado.tusId = parseInt(this.StatusChamado.tusId, 10);
                }


                axios.put(`/Telas/ConfiguracoesChamados/UpdateStatusChamados`, this.StatusChamado)
                    .then(response => {
                        if (response.status == 200) {
                            this.$mensagemAvisoSucesso("Registro Alterado.")
                            this.StatusChamado.sscId = 0;
                            this.StatusChamado.sscNomeEtapa = '';
                            this.StatusChamado.tpeId = null;
                            this.StatusChamado.tusId = null;
                            this.StatusChamado.sscOrdem = 0;

                            this.CarregaStatus(this.StatusChamado.stcId);
                        }
                    });
            }

        },
        DeleteStatus(item) {
            this.$mensagemConfirma('Tem certeza que deseja excluir?')
                .then((result) => {
                    if (result.isConfirmed) {
                        // Lógica para excluir o item
                        const param1 = item.sscId;
                        axios.delete(`/Telas/ConfiguracoesChamados/DeleteStatusChamados/${param1}`)
                            .then(response => {
                                if (response.status == 200) {
                                    this.$mensagemAvisoSucesso("Registro Excluido.")
                                    this.StatusChamado.sscId = 0;
                                    this.StatusChamado.sscNomeEtapa = '';
                                    this.StatusChamado.tpeId = null;
                                    this.StatusChamado.tusId = null;
                                    this.StatusChamado.sscOrdem = 0;

                                    this.CarregaStatus(item.stcId);
                                }
                            });
                    }
                });
        },
        EditStatusCancel() {
            this.StatusChamado.sscId = 0;
            this.StatusChamado.sscNomeEtapa = '';
            this.StatusChamado.tpeId = null;
            this.StatusChamado.tusId = null;
            this.StatusChamado.sscOrdem = 0;

            this.CarregaStatus(this.StatusChamado.stcId);
        },
        //status
        TipoPessoaSelected() {
            this.StatusChamado.tusId = null;
            if (this.StatusChamado.tpeId != 4 && this.StatusChamado.tpeId != 5){
                this.TipoUsuario = this.TipoUsuarioGeral.filter(x => x.tpeId === this.StatusChamado.tpeId);
            }
            else{

            }
        },
        async Get() {
          await axios.get(`/Telas/ConfiguracoesChamados/GetDados`)
               .then(response => {
                 this.ListTiposChamados = response.data.listaTiposChamados;
                   this.TipoPessoas = response.data.tipoPessoas;
                   this.TipoPessoas.push({tpeId: 4, tpeNome: "Cliente",tpeVisivel: true,tpeAtivo: true});
                   this.TipoPessoas.push({tpeId: 5, tpeNome: "Quem Abriu Chamado",tpeVisivel: true,tpeAtivo: true});
                    this.TipoUsuarioGeral = response.data.tipoUsuario.filter(x => x.tusVisivel).sort((a, b) => {
                        const nomeA = a.tusNome || "";
                        const nomeB = b.tusNome || "";
                        return nomeA.localeCompare(nomeB);
                    });
                    this.TipoPessoaSelected();
         });
        }
    },
    created() {
        this.Get();
    },
}
</script>

<style></style>
